import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserProvider } from "./context/UserContext"; // Agregar contexto
import Layout from "./shared/components/layout/layout";

// Importa los componentes
import Login from "./components/login/Login";
import SensorsView from "./components/sensorsview/SensorsView";
import VariableGraphContainer from "./components/sensorgraphs/VariableGraphContainer";
import Simcards from "./components/simcards/SimcardsView";
import SimcardView from "./components/simcards/SimcardView";
import SensorsAd from "./components/sensorsAd/SensorsAd";
import SensorsAdView from "./components/sensorsAd/sensorAd/SensorAdView";
import UsersView from "./components/users/UsersView";
import UserView from "./components/users/user/UserView";
import CropsView from "./components/crops/CropsView";
import CropView from "./components/crops/crop/CropView";
import ResumenView from "./components/resumen/ResumenView";
import ErrorComponent from "./components/error/ErrorComponent";
// import ProtectedRoute from "./components/roleProtectedComponent/RoleProtectedComponent";
import ProtectedRoute from "./components/protectedRoute/ProtectedRoute";

const App = () => {
  return (
    <UserProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          
          <Route element={<Layout />}>
            {/* Rutas públicas */}
            <Route path="/sensors" element={<SensorsView />} />
            <Route path="/graphs" element={<VariableGraphContainer />} />

            {/* Rutas protegidas */}
            <Route path="/simcards" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<Simcards />} />} />
            <Route path="/simcards/:simId" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<SimcardView />} />} />

            <Route path="/sensors-ad" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<SensorsAd />} />} />
            <Route path="/sensors-ad/:sensorId" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<SensorsAdView />} />} />

            <Route path="/users" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<UsersView />} />} />
            <Route path="/users/:userId" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<UserView />} />} />

            <Route path="/crops" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<CropsView />} />} />
            <Route path="/crops/:cropId" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<CropView />} />} />

            <Route path="/resumen" element={<ProtectedRoute requiredPermissions={['ROLE_ADMIN']} element={<ResumenView />} />} />
          </Route>

          <Route path="*" element={<ErrorComponent />} />
        </Routes>
      </BrowserRouter>
    </UserProvider>
  );
};

export default App;
